var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 6.52474V4.02474C15.8333 3.80373 15.7455 3.59176 15.5893 3.43548C15.433 3.2792 15.221 3.19141 15 3.19141H4.16667C3.72464 3.19141 3.30072 3.367 2.98816 3.67956C2.67559 3.99212 2.5 4.41605 2.5 4.85807C2.5 5.3001 2.67559 5.72402 2.98816 6.03658C3.30072 6.34914 3.72464 6.52474 4.16667 6.52474H16.6667C16.8877 6.52474 17.0996 6.61254 17.2559 6.76882C17.4122 6.9251 17.5 7.13706 17.5 7.35807V10.6914M17.5 10.6914H15C14.558 10.6914 14.134 10.867 13.8215 11.1796C13.5089 11.4921 13.3333 11.916 13.3333 12.3581C13.3333 12.8001 13.5089 13.224 13.8215 13.5366C14.134 13.8491 14.558 14.0247 15 14.0247H17.5C17.721 14.0247 17.933 13.9369 18.0893 13.7807C18.2455 13.6244 18.3333 13.4124 18.3333 13.1914V11.5247C18.3333 11.3037 18.2455 11.0918 18.0893 10.9355C17.933 10.7792 17.721 10.6914 17.5 10.6914Z",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.85803V16.5247C2.5 16.9667 2.67559 17.3906 2.98816 17.7032C3.30072 18.0158 3.72464 18.1914 4.16667 18.1914H16.6667C16.8877 18.1914 17.0996 18.1036 17.2559 17.9473C17.4122 17.791 17.5 17.579 17.5 17.358V14.0247",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1a7ed5a8d72633a6ba96b51d8ff504e3.svg";
export { ForwardRef as ReactComponent };